import axios from "axios";

import { errorInterceptor, unauthorizedInterceptor } from "axios/interceptors";

const basicAuthRequest = axios.create({
  baseURL: `${process.env.REACT_APP_PROXY_API_HOST}/v1`,
});

basicAuthRequest.interceptors.response.use(undefined, errorInterceptor);
basicAuthRequest.interceptors.response.use(undefined, unauthorizedInterceptor);

export default basicAuthRequest;
